export const sanitizeFileName = (name = "file") =>
  name.replace(/\s+/g, "_").replace(/[^\w\-]/g, "");
